<div class="user-course-list-container">
  <!-- Header Section -->
  <div class="header-section">
    <div class="container">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h1 class="page-title">
            <i class="bi bi-book-half me-2"></i>
            รายการคอร์สที่เรียนแล้ว
          </h1>
          <p class="page-subtitle">ประวัติการเรียนและชั่วโมง CPD ของคุณ</p>
        </div>
        <button class="btn btn-outline-light" (click)="goBack()">
          <i class="bi bi-arrow-left me-2"></i>
          กลับหน้าหลัก
        </button>
      </div>
    </div>
  </div>

  <!-- Statistics Section -->
  <div class="statistics-section" *ngIf="!error && cpdRecords.length > 0">
    <div class="container">
      <!-- First Row - Main CPD Hours -->
      <div class="row g-4 mb-3">
        <div class="col-lg-6 col-md-6">
          <div class="stat-card stat-primary stat-large">
            <div class="stat-icon">
              <i class="bi bi-clock-history"></i>
            </div>
            <div class="stat-content">
              <h3>{{ verifiedHours }}</h3>
              <p>VAT CPD ที่ใช้ได้</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="stat-card stat-sec stat-large">
            <div class="stat-icon">
              <i class="bi bi-award-fill"></i>
            </div>
            <div class="stat-content">
              <h3>{{ secCertifiedHours }}</h3>
              <p>ชั่วโมง CPD ที่ กลต. รับรอง</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Second Row - Details -->
      <div class="row g-4">
        <div class="col-lg-4 col-md-4 col-sm-6">
          <div class="stat-card stat-success">
            <div class="stat-icon">
              <i class="bi bi-check-circle-fill"></i>
            </div>
            <div class="stat-content">
              <h3>{{ verifiedHours }}</h3>
              <p>ชั่วโมงที่ตรวจสอบแล้ว</p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6">
          <div class="stat-card stat-warning">
            <div class="stat-icon">
              <i class="bi bi-hourglass-split"></i>
            </div>
            <div class="stat-content">
              <h3>{{ unverifiedHours }}</h3>
              <p>ชั่วโมงรอตรวจสอบ</p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6">
          <div class="stat-card stat-info">
            <div class="stat-icon">
              <i class="bi bi-journal-bookmark-fill"></i>
            </div>
            <div class="stat-content">
              <h3>{{ totalCourses }}</h3>
              <p>คอร์สที่เรียนแล้ว</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <div class="container">
      <!-- Error State -->
      <div *ngIf="error" class="alert alert-danger d-flex align-items-center" role="alert">
        <i class="bi bi-exclamation-triangle-fill me-3" style="font-size: 1.5rem;"></i>
        <div class="flex-grow-1">
          <strong>เกิดข้อผิดพลาด</strong>
          <p class="mb-0">{{ error }}</p>
        </div>
        <button class="btn btn-outline-danger ms-3" (click)="retry()">
          <i class="bi bi-arrow-clockwise me-2"></i>
          ลองใหม่
        </button>
      </div>

      <!-- Course List -->
      <div *ngIf="!error" class="course-list">
        <!-- Empty State -->
        <div *ngIf="cpdRecords.length === 0" class="empty-state">
          <i class="bi bi-inbox"></i>
          <h3>ยังไม่มีประวัติการเรียน</h3>
          <p>คุณยังไม่มีคอร์สที่เรียนแล้ว</p>
          <button class="btn btn-primary" (click)="goBack()">
            <i class="bi bi-arrow-left me-2"></i>
            กลับหน้าหลัก
          </button>
        </div>

        <!-- Course Cards -->
        <div *ngIf="cpdRecords.length > 0" class="row g-4">
          <div class="col-12" *ngFor="let record of cpdRecords; let i = index">
            <div class="course-card" [class.verified]="record.isVerified">
              <div class="course-card-header">
                <div class="course-thumbnail">
                  <img *ngIf="record.course.thumbnail" [src]="record.course.thumbnail" [alt]="record.course.title">
                  <div *ngIf="!record.course.thumbnail" class="thumbnail-placeholder">
                    <i class="bi bi-book"></i>
                  </div>
                </div>
                <div class="course-info flex-grow-1">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <h4 class="course-title">{{ record.course.title }}</h4>
                    <span class="verification-badge" [class.verified]="record.isVerified">
                      <i class="bi" [class.bi-check-circle-fill]="record.isVerified"
                        [class.bi-clock-history]="!record.isVerified"></i>
                      {{ record.isVerified ? 'ตรวจสอบแล้ว' : 'รอตรวจสอบ' }}
                    </span>
                  </div>
                  <div class="course-meta">
                    <span class="meta-item">
                      <i class="bi bi-calendar-event"></i>
                      {{ formatDate(record.studyDate) }}
                    </span>
                    <span class="meta-item">
                      <i class="bi bi-clock-fill"></i>
                      จำนวน CPD : {{ record.hoursStudied }} ชั่วโมง
                    </span>
                  </div>
                </div>
              </div>

              <div class="course-card-body">
                <div class="row g-3">

                  <div class="col-md-3 col-sm-6">
                    <div class="info-box">
                      <label>ค่าเรียนรวม VAT</label>
                      <span class="value">฿{{ formatPrice(record.course.price) }}</span>
                    </div>
                  </div>

                  <!-- Expiry Status -->
                  <div class="col-md-3 col-sm-6" *ngIf="record.course.endDate">
                    <div class="info-box">
                      <label>
                        <i class="bi bi-calendar-check me-1"></i>
                        สถานะความใช้งาน
                      </label>
                      <span [class]="getExpiryStatusBadgeClass(record.course.endDate)">
                        <i class="bi" [class.bi-check-circle-fill]="!isCourseExpired(record.course.endDate)"
                          [class.bi-x-circle-fill]="isCourseExpired(record.course.endDate)"></i>
                        {{ getExpiryStatusText(record.course.endDate) }}
                      </span>
                    </div>
                  </div>

                  <!-- SEC Certification -->
                  <div class="col-md-3 col-sm-6">
                    <div class="info-box">
                      <label>
                        <i class="bi bi-shield-check me-1"></i>
                        กลต.รับรอง
                      </label>
                      <span class="badge" [ngClass]="record.course.certificationBySEC ? 'bg-success' : 'bg-danger'">
                        {{ record.course.certificationBySEC ? 'รองรับ' : 'ไม่รองรับ' }}
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Status Information Row -->
                <div class="row g-3 mt-2" *ngIf="record.cpdCourseStatus || record.cpdPaymentStatus">
                  <div class="col-md-6 col-sm-6" *ngIf="record.cpdCourseStatus">
                    <div class="info-box">
                      <label>สถานะการลงทะเบียนอบรม</label>
                      <span class="badge" [ngClass]="getCpdCourseStatusBadgeClass(record.cpdCourseStatus.name)">
                        {{ record.cpdCourseStatus.name }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-6" *ngIf="record.cpdPaymentStatus">
                    <div class="info-box">
                      <label>สถานะการชำระเงิน</label>
                      <span class="badge" [ngClass]="getCpdPaymentStatusBadgeClass(record.cpdPaymentStatus.name)">
                        {{ record.cpdPaymentStatus.name }}
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Payment Slip Upload Section (Only show when cpdPaymentStatusId = 1) -->
                <div class="payment-slip-section mt-3" *ngIf="record.cpdPaymentStatusId === 1">
                  <div class="alert alert-warning d-flex align-items-center mb-3">
                    <i class="bi bi-exclamation-triangle-fill me-2"></i>
                    <span>กรุณาอัปโหลดสลิปการชำระเงินเพื่อยืนยันการชำระเงิน</span>
                  </div>

                  <div class="payment-slip-upload-box">
                    <!-- Receipt Type Selection Section (บุคคลธรรมดา / นิติบุคคล) -->
                    <div class="receipt-type-selection-section mb-3">
                      <label class="section-label">
                        <i class="bi bi-file-earmark-text me-2"></i>
                        {{ isReceiptTypeReadOnly(record.id) ? 'ประเภทใบเสร็จที่เลือก:' : 'เลือกประเภทใบเสร็จ:' }}
                      </label>

                      <!-- Read-only view when receipt type is already set -->
                      <div *ngIf="isReceiptTypeReadOnly(record.id)" class="receipt-type-readonly">
                        <div class="selected-receipt-type">
                          <i class="bi" [class.bi-person-circle]="getReceiptType(record.id) === 'individual'"
                            [class.bi-building]="getReceiptType(record.id) === 'company'"></i>
                          <span>{{ getReceiptTypeLabel(getReceiptType(record.id)) }}</span>
                          <span class="badge bg-success ms-2">
                            <i class="bi bi-check-circle me-1"></i>
                            บันทึกแล้ว
                          </span>
                        </div>
                        <small class="text-muted d-block mt-2">
                          <i class="bi bi-info-circle me-1"></i>
                          ประเภทใบเสร็จถูกบันทึกแล้ว ไม่สามารถแก้ไขได้
                        </small>
                      </div>

                      <!-- Editable radio buttons when receipt type is not set -->
                      <div *ngIf="!isReceiptTypeReadOnly(record.id)" class="radio-group">
                        <div class="radio-option">
                          <input type="radio" [id]="'individual-' + record.id"
                            [name]="'receiptType-' + record.id" value="individual"
                            [checked]="getReceiptType(record.id) === 'individual'"
                            (change)="onReceiptTypeChange(record.id, 'individual')">
                          <label [for]="'individual-' + record.id" class="radio-label">
                            <i class="bi bi-person-circle me-1"></i>
                            ออกใบเสร็จแบบบุคคลธรรมดา
                          </label>
                        </div>
                        <div class="radio-option">
                          <input type="radio" [id]="'company-' + record.id"
                            [name]="'receiptType-' + record.id" value="company"
                            [checked]="getReceiptType(record.id) === 'company'"
                            (change)="onReceiptTypeChange(record.id, 'company')">
                          <label [for]="'company-' + record.id" class="radio-label">
                            <i class="bi bi-building me-1"></i>
                            ออกใบเสร็จแบบนิติบุคคล
                          </label>
                        </div>
                      </div>
                    </div>

                    <!-- Payment Channel: bank account for transfer -->
                    <div class="payment-channel-section mb-3">
                      <label class="form-label" style="font-weight:600;color:#334155;">
                        <i class="bi bi-bank2 me-2"></i>ช่องทางการชำระเงิน
                      </label>
                      <div style="border:1px solid #bfdbfe;background:#eff6ff;border-radius:10px;padding:14px 16px;">
                        <div style="color:#475569;">ชำระโดยโอนเข้าบัญชี</div>
                        <div style="font-weight:700;color:#1e293b;margin:2px 0;">
                          &ldquo;โครงการฝึกอบรม สมาคมผู้ประเมินค่าทรัพย์สินแห่งประเทศไทย&rdquo;
                        </div>
                        <div style="display:flex;align-items:center;flex-wrap:wrap;gap:10px;margin-top:6px;">
                          <span style="display:inline-flex;align-items:center;gap:6px;color:#1d4ed8;font-weight:600;">
                            <i class="bi bi-credit-card-2-front-fill"></i>ธนาคารกรุงเทพ
                          </span>
                          <span style="font-family:monospace;font-size:1.05rem;font-weight:700;color:#0f172a;letter-spacing:0.5px;">
                            เลขที่ 137-098710-7
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Transfer Date-Time Section -->
                    <div class="transfer-datetime-section mb-3">
                      <label class="form-label datetime-label">
                        <i class="bi bi-clock-history me-2"></i>
                        แจ้งวันที่และเวลาการโอนเงิน
                        <span class="text-danger">*</span>
                      </label>
                      <div class="datetime-input-wrapper">
                        <input type="datetime-local" [id]="'transferDateTime-' + record.id"
                          class="form-control datetime-input"
                          (change)="onTransferDateTimeChange(record.id, $event)"
                          [max]="currentYear + '-12-31T23:59'"
                          [disabled]="isUploadingSlip(record.id)" required>
                        <small class="form-text text-muted d-block mt-2">
                          <i class="bi bi-info-circle me-1"></i>
                          กรุณาระบุวันที่และเวลาที่ทำการโอนเงินจริง
                        </small>
                        <!-- Display formatted date-time if selected -->
                        <div class="selected-datetime-display mt-2" *ngIf="getTransferDateTime(record.id)">
                          <i class="bi bi-check-circle-fill text-success me-2"></i>
                          <span class="datetime-text">{{ getTransferDateTime(record.id) }}</span>
                        </div>
                      </div>
                    </div>

                    <label class="form-label">
                      <i class="bi bi-receipt me-2"></i>
                      อัปโหลดสลิปการชำระเงิน
                    </label>

                    <!-- File Input -->
                    <div class="file-upload-wrapper" *ngIf="!hasPaymentSlip(record.id)">
                      <input type="file" class="form-control" [id]="'paymentSlip-' + record.id"
                        accept="image/jpeg,image/jpg" (change)="onPaymentSlipSelected($event, record.id)">
                      <small class="form-text text-muted">
                        <i class="bi bi-info-circle me-1"></i>
                        รองรับไฟล์ JPG, JPEG เท่านั้น (ขนาดไม่เกิน 5MB)
                      </small>
                    </div>

                    <!-- Preview and Upload Button -->
                    <div class="payment-slip-preview" *ngIf="hasPaymentSlip(record.id)">
                      <div class="preview-container">
                        <img [src]="paymentSlipPreviews[record.id]" alt="Payment Slip Preview">
                        <button type="button" class="btn btn-sm btn-danger remove-btn"
                          (click)="removePaymentSlip(record.id)" [disabled]="isUploadingSlip(record.id)">
                          <i class="bi bi-x-circle"></i>
                        </button>
                      </div>
                      <div class="upload-actions mt-2">
                        <button type="button" class="btn btn-success" (click)="uploadPaymentSlip(record.id)"
                          [disabled]="isUploadingSlip(record.id) || !getTransferDateTime(record.id) || !getReceiptType(record.id)">
                          <span *ngIf="!isUploadingSlip(record.id)">
                            <i class="bi bi-cloud-upload me-2"></i>
                            ส่งสลิปการชำระเงิน
                          </span>
                          <span *ngIf="isUploadingSlip(record.id)">
                            <span class="spinner-border spinner-border-sm me-2"></span>
                            กำลังอัปโหลด...
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="course-card-footer">
                <div class="footer-info">
                  <small class="text-muted">
                    <i class="bi bi-calendar-plus me-1"></i>
                    บันทึกเมื่อ: {{ formatDate(record.createdAt) }}
                  </small>
                  <div class="footer-buttons">
                    <!-- คอร์สใหม่ (ตั้งแต่ ส.ค. 2569): ดาวน์โหลดใบเสร็จ + E-Certificate -->
                    <ng-container *ngIf="isNewCourseForEcert(record)">
                      <button *ngIf="record.cpdPaymentStatus?.name === 'ชำระเงินเสร็จสิ้น'" class="btn btn-receipt"
                        (click)="downloadReceipt(record.id)" title="ดาวน์โหลดใบเสร็จ">
                        <i class="bi bi-receipt me-2"></i>
                        ดาวน์โหลดใบเสร็จ
                      </button>
                      <button class="btn btn-certificate" (click)="downloadCertificate(record)"
                        [disabled]="!record.isCompleted"
                        [title]="record.isCompleted ? 'ดาวน์โหลดใบประกาศนียบัตร' : 'คอร์สยังเรียนไม่จบ'">
                        <i class="bi bi-download me-2"></i>
                        Download Certificate
                      </button>
                    </ng-container>

                    <!-- คอร์สเก่า (ก่อน ส.ค. 2569): ดาวน์โหลดได้เฉพาะใบประกาศแบบกระดาษที่แนบไว้ -->
                    <button *ngIf="!isNewCourseForEcert(record)" class="btn btn-certificate"
                      (click)="downloadEvidence(record)"
                      [disabled]="!hasEvidence(record)"
                      [title]="hasEvidence(record) ? 'ดาวน์โหลดใบประกาศ (หลักฐานที่แนบตอนลงทะเบียน)' : 'ไม่มีหลักฐานแนบในระบบ'">
                      <i class="bi bi-file-earmark-image me-2"></i>
                      ดาวน์โหลดใบประกาศ
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>